package features.videoDetails

import com.kinoshazam.model.Features
import models.Cast
import models.VideoDetails
import features.watch.model.WatchTarget
import utils.UiAction
import utils.UiState

data class VideoDetailsState(
    val isLoading: Boolean = true,
    val isEpisodesLoading: Boolean = true,
    val isError: Boolean = false,
    val error: String? = null,
    val videoInfo: VideoDetails? = null,
    val isFullDescription: Boolean = false,
    val selectedSeason: VideoDetails.Season? = null,
    val selectedEpisode: VideoDetails.Episode? = null,
    val videoCast: Cast? = null,
    val similarMovie: List<VideoDetails>? = null,
    val isFavorite: Boolean = false,
    val watchTarget: WatchTarget? = null,
    val features: Features,
) : UiState

sealed interface DetailsMVIAction : UiAction {
    data object Reload : DetailsMVIAction
    data object BackClicked : DetailsMVIAction
    data object ClickMore : DetailsMVIAction
    data class OnSeasonClicked(val videoId: Int, val season: VideoDetails.Season) :
        DetailsMVIAction

    data class OnEpisodeClicked(val videoId: Int, val episode: VideoDetails.Episode) :
        DetailsMVIAction

    data class AddToFavorite(val videoId: Int) : DetailsMVIAction
    data class OnPlayClicked(val url: String) : DetailsMVIAction
    data class OnVideoClicked(val id: Int) : DetailsMVIAction
    data class OnActorClicked(val personId: Int) : DetailsMVIAction
}